export default __webpack_public_path__ + "static/media/00.e9d8b025.jpg";